import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from '@binance-chain/honeycomb'

import { useI18n } from '../../i18n/util'

import {
  Connection,
  Option,
  OptionContent,
  LeftContent,
  TypeName,
  ImgWrap,
  BinanceChain,
  LeftSide,
} from '../../components/walletmodal'

const CHROME_WE_STORE_URL =
  'https://chrome.google.com/webstore/detail/binance-chain-wallet/fhbohimaelbohpjbbldcngcnapndodjp'

function CreateWallet({ open, onClose }) {
  const { formatI18nText } = useI18n()

  return (
    <Modal open={open} onClose={onClose}>
      <Modal.Header title={formatI18nText('createWallet.modal.title')} />
      <Modal.Content>
        <Connection>
          <Option href={CHROME_WE_STORE_URL} target="_blank">
            <OptionContent>
              <LeftSide>
                <TypeName>{formatI18nText('createWallet.option.install.extension.title')}</TypeName>
              </LeftSide>
              <LeftContent>
                {formatI18nText('createWallet.option.install.extension.content')}
              </LeftContent>
            </OptionContent>
            <ImgWrap>
              <BinanceChain />
            </ImgWrap>
          </Option>
        </Connection>
      </Modal.Content>
    </Modal>
  )
}

CreateWallet.propTypes = {
  open: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default CreateWallet
